import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useTable } from 'hooks'
import { users } from 'orm'
import { getColumns } from './model'

import { toDepartments } from 'ducks/router'
import type { TableQuery } from 'hooks/useTable'

const useDepartmentDetailsTableMutations = () => {
  const dispatch = useDispatch()

  const handleFetchUsers = React.useCallback(
    ({ limit, department, offset, ordering, search }: TableQuery) => {
      dispatch(
        users.fetchStart({ limit, department, offset, ordering, search }),
      )
    },
    [dispatch],
  )

  return {
    handleFetchUsers,
  }
}

const useDepartmentDetailsTableData = () => {
  const data = useSelector(users.getModel)

  const { count, items = [], order = [] } = data ?? {}

  return {
    state: { count, items, order },
  }
}

export const useDepartmentDetailsTable = state => {
  const { mapSortingPropToQueryParam, search, id } = state

  const columns = getColumns()
  const dispatch = useDispatch()
  const { handleFetchUsers } = useDepartmentDetailsTableMutations()

  const {
    state: { count, items, order },
  } = useDepartmentDetailsTableData()

  const handleRefetch = React.useCallback(
    ({ limit, offset, ordering, search }: TableQuery) => {
      handleFetchUsers({ department: [id], limit, offset, ordering, search })
    },
    [handleFetchUsers, id],
  )

  const handleQueriesUpdate = React.useCallback(
    ({ limit, offset, ordering, search }: TableQuery) => {
      dispatch(toDepartments(id, { limit, offset, ordering, search }))
    },
    [dispatch],
  )

  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  } = useTable({
    columns,
    data: order.map(key => items[key]),
    mapSortingPropToQueryParam,
    pageCount: count,
    search,
    fetchAction: handleRefetch,
    updateQueriesAction: handleQueriesUpdate,
  })

  return {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  }
}
